import React from "react";

const Heading = ({ heading = "Heading" }) => {
    return <h6 className="fw-bold">{heading}</h6>;
};

export default Heading;
